// Every page in the app, grouped the way the sidebar shows them (`section`
// is the small heading above each item). App.js
// builds the routes from this list too, so a page added here gets both.
import SpaceDashboardOutlinedIcon from "@mui/icons-material/SpaceDashboardOutlined";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import SettingsOutlinedIcon from "@mui/icons-material/SettingsOutlined";
import FactCheckOutlinedIcon from "@mui/icons-material/FactCheckOutlined";
import SavingsOutlinedIcon from "@mui/icons-material/SavingsOutlined";
import QueryStatsOutlinedIcon from "@mui/icons-material/QueryStatsOutlined";

import Analytics from "./pages/Insight/Insight";
import Approval from "./pages/Approvals/Approvals";

import Invest from "./pages/Add Investment/AddInvestment";
import UndefinedInvest from "./pages/Undefined Investment/UndefinedRate";
import InvestmentType from "./pages/Investment Type/InvestmentType";
import Institution from "./pages/Institution/Institution";
import Regulator from "./pages/Regulators/Regulator";
import Impairment from "./pages/Impairment/Impairement";
import Redemption from "./pages/Redemption/Redemption";

import InvestmentReport from "./pages/Investment Report/Report";
import RegulatorReport from "./pages/regulator Report/RegulatorReport";
import InvestmentTypeReport from "./pages/investmentType/investmentTypeReport";
import InstitutionReport from "./pages/InstittutionReport/InstitutionReport";
import TenureReport from "./pages/TenureReport/TenureReport";
import GroupedReport from "./pages/Grouped Report/GroupedReport";

import UndefinedInvestmentReport from "./pages/UndefinedRateReport/Report";
import UndefinedRegulatorReport from "./pages/regulator Report undefined/RegulatorReport";
import UndefinedInvestmentTypeReport from "./pages/UndefinedInvestmentTypeReport/investmentTypeReport";
import UndefinedInstitutionReport from "./pages/UndefinedInstitutionReport/InstitutionReport";
import UndefinedTenureReport from "./pages/UndefinedTenureReport/TenureReport";

import IndividualInvest from "./pages/Add Individual Investment/AddInvestment";
import CustomersDetailedInvestmentReport from "./pages/Customers Investement Report/Report";
import CustomersApproval from "./pages/Customers Investment Approvals/Approvals";

import { ProfileSettings, SecuritySettings } from "./user page/Settings";

const P = "/investment";

export const NAV = [
  {
    label: "Dashboard",
    section: "Overview",
    icon: <SpaceDashboardOutlinedIcon />,
    path: `${P}/`,
    title: "Dashboard",
    element: <Analytics />,
  },
  {
    label: "Investments",
    section: "Investments",
    icon: <SavingsOutlinedIcon />,
    children: [
      { label: "Defined Rate", path: `${P}/investments/defined-rate`, element: <Invest /> },
      { label: "Undefined Rate", path: `${P}/investments/undefined-rate`, element: <UndefinedInvest /> },
      { label: "Investment Types", path: `${P}/investments/types`, element: <InvestmentType /> },
      { label: "Institutions", path: `${P}/investments/institutions`, element: <Institution /> },
      { label: "Regulators", path: `${P}/investments/regulators`, element: <Regulator /> },
      { label: "Impairment", path: `${P}/investments/impairment`, element: <Impairment /> },
      { label: "Rediscount", path: `${P}/investments/rediscount`, element: <Redemption /> },
      { label: "Customers Investment", path: `${P}/investments/customers`, element: <IndividualInvest /> },
    ],
  },
  {
    label: "Investment Reports",
    section: "Reports",
    icon: <AssessmentOutlinedIcon />,
    children: [
      { label: "Investment", path: `${P}/reports/investment`, element: <InvestmentReport /> },
      { label: "Regulator", path: `${P}/reports/regulator`, element: <RegulatorReport /> },
      { label: "Investment Type", path: `${P}/reports/investment-type`, element: <InvestmentTypeReport /> },
      { label: "Institution", path: `${P}/reports/institution`, element: <InstitutionReport /> },
      { label: "Tenure", path: `${P}/reports/tenure`, element: <TenureReport /> },
      { label: "Summary", path: `${P}/reports/summary`, element: <GroupedReport /> },
    ],
  },
  {
    label: "Customers Inv. Report",
    section: "Reports",
    icon: <AssessmentOutlinedIcon />,
    path: `${P}/customers-investment-report`,
    element: <CustomersDetailedInvestmentReport />,
    approversOnly: true,
  },
  {
    label: "Undefined Rate Reports",
    section: "Reports",
    icon: <QueryStatsOutlinedIcon />,
    children: [
      { label: "Investment", path: `${P}/undefined-reports/investment`, element: <UndefinedInvestmentReport /> },
      { label: "Regulator", path: `${P}/undefined-reports/regulator`, element: <UndefinedRegulatorReport /> },
      { label: "Investment Type", path: `${P}/undefined-reports/investment-type`, element: <UndefinedInvestmentTypeReport /> },
      { label: "Institution", path: `${P}/undefined-reports/institution`, element: <UndefinedInstitutionReport /> },
      { label: "Tenure", path: `${P}/undefined-reports/tenure`, element: <UndefinedTenureReport /> },
    ],
  },
  {
    label: "Approvals",
    section: "Overview",
    icon: <FactCheckOutlinedIcon />,
    path: `${P}/approval`,
    element: <Approval />,
    approversOnly: true,
    // red count of investments waiting for approval
    showAwaiting: true,
  },
  {
    label: "Customers Approvals",
    section: "Overview",
    icon: <FactCheckOutlinedIcon />,
    path: `${P}/customers-investment-approval`,
    element: <CustomersApproval />,
    approversOnly: true,
  },
  {
    label: "Settings",
    section: "Account",
    icon: <SettingsOutlinedIcon />,
    children: [
      { label: "Profile", path: `${P}/settings/profile`, element: <ProfileSettings /> },
      { label: "Security", path: `${P}/settings/security`, element: <SecuritySettings /> },
    ],
  },
];

// Old addresses (bookmarks, links in emails) and where they now live
export const REDIRECTS = {
  [`${P}/dashboard`]: `${P}/`,
  [`${P}/all-investment`]: `${P}/investments/defined-rate`,
  [`${P}/defined-rate-report`]: `${P}/reports/investment`,
  [`${P}/undefined-rate-report`]: `${P}/undefined-reports/investment`,
  [`${P}/user-page`]: `${P}/settings/profile`,
};

// Every page as one flat list, each with its browser-tab title
export const PAGES = NAV.flatMap((item) =>
  item.children
    ? item.children.map((child) => ({
        ...child,
        title: `${child.label} | ${item.label}`,
      }))
    : [{ ...item, title: item.title || item.label }],
);
